import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// n8n webhook base URL 改由環境變數注入，避免把內部服務網址硬編進前端 bundle。
// 未設定時 fallback 到既有網址，確保現有功能不受影響。
const BARKING_DOG_N8N_WEBHOOK_URL = import.meta.env.VITE_N8N_WEBHOOK_URL || "https://n8n.thebarkingdog.tw/webhook";

// 添加超時處理和錯誤處理,確保 n8n 服務掛掉時不會阻塞應用
const baseQuery = fetchBaseQuery({
    baseUrl: BARKING_DOG_N8N_WEBHOOK_URL,
    timeout: 10000, // 10 秒超時
});

// 自定義 baseQuery 包裝器,添加錯誤處理邏輯
const baseQueryWithErrorHandling: typeof baseQuery = async (args, api, extraOptions) => {
    try {
        const result = await baseQuery(args, api, extraOptions);
        // 如果請求失敗,記錄錯誤但不阻塞應用

        return result;
    } catch (error) {
        // 捕獲網路錯誤或超時,返回空結果而非拋出錯誤
        return {
            error: {
                status: "FETCH_ERROR",
                error: String(error),
            },
        };
    }
};

export const n8nApiSlice = createApi({
    baseQuery: baseQueryWithErrorHandling,
    tagTypes: ["n8n_DemoWebsiteUrl", "n8n_UserPermission", "n8n_PromptTemplate"],
    endpoints: () => ({}),
    reducerPath: "n8nApiSlice",
});
